<template>
  <div class="klaviyo-form-content" :class="{ 'mobile-only': showOnMobile }">
    <div :class="formId"></div>
  </div>
</template>

<script>
export default {
  name: "KlaviyoForm",
  props: {
    formId: {
      type: String,
      default: "klaviyo-form-XCcL6a",
    },
    showOnMobile: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Stay Updated",
    },
    description: {
      type: String,
      default: "Get the latest insights delivered to your inbox.",
    },
  },
};
</script>

<style scoped>
.klaviyo-form-content {
  margin: 3rem 0;
  padding: 0;
}

/* Hide by default on desktop when showOnMobile is true */
.klaviyo-form-content.mobile-only {
  display: none;
}

/* Show on mobile when showOnMobile is true */
@media (max-width: 1024px) {
  .klaviyo-form-content.mobile-only {
    display: block;
  }
}

/* Ensure Klaviyo form is responsive */
.klaviyo-form-content :deep(.klaviyo-form-XCcL6a) {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  position: static !important;
  z-index: auto !important;
  transform: none !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  bottom: auto !important;
  box-shadow: none !important;
  contain: layout style paint;
}

.klaviyo-form-content :deep(.klaviyo-form-XCcL6a *) {
  position: static !important;
  z-index: auto !important;
  transform: none !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  bottom: auto !important;
}

.klaviyo-form-content :deep(.klaviyo-form-XCcL6a [class*="modal"]),
.klaviyo-form-content :deep(.klaviyo-form-XCcL6a [class*="overlay"]),
.klaviyo-form-content :deep(.klaviyo-form-XCcL6a [class*="popup"]) {
  display: none !important;
}

/* Mobile specific styling */
@media (max-width: 768px) {
  .klaviyo-form-content {
    margin: 2rem 0;
  }
}
</style>
